import axios from "axios";
import { handleHttpErrors } from "../../../modules/http";

const initialState = {};

export const addParticipantReducer = (state = initialState, action) => {
  return state;
};

const addParticipant = (formData) => (dispatch, getState) => {
  return axios
    .post(`/api/participant/invite`, formData)
    .then(({ data }) => {
      return Promise.resolve({
        message: "Participant created successfully",
        participant: { participantId: data?.id, userName: data?.ugnxId },
      });
    })
    .catch((error) => {
      const defaultMessage = error.response?.data
        ? error.response?.data
        : "The participant is already associated with that Study.";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

export const mapDispatchToProps = {
  addParticipant,
};
